import { deepDive } from "@/mocks/homeContent";
import { Eyebrow } from "./Common";

export default function DeepDive() {
  return (
    <section id="deep" className="bg-secondary-950 py-14 md:py-20 scroll-mt-16 md:scroll-mt-20">
      <div className="container-page">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <Eyebrow tone="dark">{deepDive.eyebrow}</Eyebrow>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">{deepDive.title}</h2>
            <div className="mt-5 space-y-4 text-sm leading-loose text-background-200/85 md:text-base">
              {deepDive.paragraphs.map((p) => (
                <p key={p.slice(0, 12)}>{p}</p>
              ))}
            </div>
            <ul className="mt-6 space-y-3">
              {deepDive.points.map((pt) => (
                <li key={pt} className="flex items-start gap-3 text-sm font-medium text-background-100 md:text-[15px]">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-accent-500 text-foreground-950">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  {pt}
                </li>
              ))}
            </ul>
            <div className="mt-7 flex flex-wrap gap-3">
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-4 py-2 text-xs font-medium text-background-100 ring-1 ring-background-50/20">
                <i className="ri-calendar-line"></i> 编辑部专栏 · 每周三更新
              </span>
            </div>
          </div>

          <figure className="relative overflow-hidden rounded-lg">
            <img src={deepDive.image} alt="编辑部深度解读专栏插画" className="h-[340px] w-full object-cover object-top md:h-[460px]" />
            <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/70 to-transparent"></div>
            <figcaption className="absolute bottom-4 left-4 right-4 rounded-md bg-background-50/10 px-4 py-3 text-xs leading-relaxed text-background-100 backdrop-blur-sm md:text-sm">
              「慢吃瓜」不是慢吞吞，而是把每一份围观都建立在可查证的时间线之上。
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}